import type { EditPermissionDialogProps } from "./types-edit-permission-dialog";
import { useEditPermissionDialog } from "./use-edit-permission-dialog";
import { EditPermissionDialogView } from "./view-edit-permission-dialog";

/** Modal "Editar permissão" (HU 902). */
export function EditPermissionDialog(props: EditPermissionDialogProps) {
  const vm = useEditPermissionDialog(props);

  return <EditPermissionDialogView {...vm} />;
}

export type * from "./types-edit-permission-dialog";
